<template>
  <div class="outer-wrap">
    <div class="rule-group">
      <div v-show="showRows" class="left-cond-wrap">
        <div class="v-line up">
          <div class="h-line"></div>
        </div>
        <el-select
          v-model="formData.operationSymbol"
          style="width: 60px"
          size="small"
          placeholder="关系"
        >
          <el-option label="且" value="and"></el-option>
          <el-option label="或" value="or"></el-option>
        </el-select>
        <div class="v-line down">
          <div class="h-line"></div>
        </div>
      </div>
      <div class="right-rule-wrap">
        <div class="rule-row" v-for="(item, index) in formData.rows" :key="item.id">
          <div class="rule-row-content">
            <form-item labelAlign="left" label="值">
              <el-select
                v-model="item.oper"
                class="m-2 rule-row-item"
                placeholder="请选择操作符"
                @change="operatorChange(index)"
                :size="styleConfig?.size || 'default'"
              >
                <template v-for="op in operatorsList" :key="op.key">
                  <el-option
                    :label="op.label"
                    :value="op.key"
                  />
                </template>
              </el-select>
              <el-input-number
                :controls="false"
                v-model="item.fixedValue"
                class="rule-row-item m-2"
                :size="styleConfig?.size || 'default'"
              />
            </form-item>
          </div>
          <div class="btns">
            <el-icon
              class="ml-4 pointer hover"
              @click="handleAddClick"
              title="添加项"
            >
              <CirclePlus />
            </el-icon>
            <el-icon
              class="ml-4 pointer hover"
              @click="handleRemoveClick(index)"
              title="删除"
              v-if="formData.rows.length > 1"
            >
              <Delete />
            </el-icon>
            <el-icon
              class="ml-4 pointer hover"
              @click="handleCleanClick(index)"
              title="清空"
            >
              <CircleClose />
            </el-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { ElMessage } from "element-plus";
import { operators } from "@/option/common/dict.js";
import { CirclePlus, Delete, CircleClose } from "@element-plus/icons-vue";

const props = defineProps({
  data: {
    type: Object,
  },
  formDef: {
    type: Object,
    default: function () {
      return {};
    },
  },
  level: {
    type: Number,
    default: 1,
  },
  // 样式配置项
  styleConfig: {},
});
const errorTip = ElMessage.error;
const emit = defineEmits(["up"]);
const formData = computed({
  get() {
    return props.data;
  },
  set(v) {
    console.log(v);
  },
});
const showRows = computed(() => {
  return formData.value.rows && formData.value.rows.length > 1;
});

const operatorsList = ref([
  {
    key: "=",
    label: "等于(=)",
  },
  {
    key: "<>",
    label: "不等于(<>)",
  },
  {
    key: ">",
    label: "大于(>)",
  },
  {
    key: "<",
    label: "小于(<)",
  },
]);

function operatorChange(index) {
  formData.value.rows[index].fixedValue = "";
  formData.value.rows[index].filterValueList = [];
  formData.value.rows[index].valueType = "";
}

function createNewNodeData() {
  let obj = {
    ruletype: "d",
    id: getUUID(),
    operationSymbol: "and",
  };
  Object.assign(obj, props.formDef);
  return obj;
}

function handleAddClick() {
  formData.value.rows.push(createNewNodeData());
}

function handleRemoveClick(index) {
  // 增加删除判断,最后一个不可以删除
  if (props.level == 1 && formData.value.rows.length == 1) {
    errorTip("根节点不可以删除");
    return;
  }
  formData.value.rows.splice(index, 1);
  if (formData.value.rows.length == 1) {
    let obj = formData.value.rows[0];
    emit("up", obj);
  }
}

function handleCleanClick(index) {
  formData.value.rows[index] = {
    ruletype: formData.value.rows[index].ruletype,
    id: getUUID(),
    operationSymbol: "and",
  };
}

let index = 1;

function getUUID() {
  return new Date().getTime() + "-" + index++;
}

function changeToFormData(fp, keyCode) {
  let newFp = {
    operationSymbol: fp.operationSymbol,
    children: [],
  };
  newFp[keyCode] = [];
  fp.rows.forEach((child) => {
    child.type = child?.fieldMap?.type || "";
    child.code = child?.fieldMap?.code || "";
    child.fieldType = child?.fieldMap?.fieldType || "";
    child.fixedValue = String(child?.fixedValue);
    if (child.valueType == "pageEntry") {
      child.fixedValue = "";
    }
    if (child.ruletype == "d") {
      let nb = JSON.parse(JSON.stringify(child));
      delete nb.ruletype;
      delete nb.id;
      newFp[keyCode].push(nb);
    } else {
      newFp.children.push(changeToFormData(child, keyCode));
    }
  });
  return newFp;
}

function changeToComponentData(fp, keyCode) {
  console.log(fp, newFp, keyCode, 999999999);
  let newFp = {
    id: fp.id || getUUID(),
    operationSymbol: fp.operationSymbol,
    rows: [],
  };
  fp[keyCode].forEach((gf) => {
    let nb = JSON.parse(JSON.stringify(gf));
    nb.ruletype = "d";
    newFp.rows.push(nb);
  });
  fp.children.forEach((child) => {
    let nb = JSON.parse(JSON.stringify(child));
    nb.ruletype = "c";
    newFp.rows.push(changeToComponentData(nb, keyCode));
  });

  return newFp;
}

defineExpose({
  changeToFormData,
  changeToComponentData,
});
</script>

<style lang="scss" scoped>
.flex-shrink {
  flex-shrink: 0;
}

.number-range {
  display: flex;
  align-items: center;
}

.outer-wrap {
  overflow: auto;
  //background-color: #fff;
  display: inline-block;
  min-width: 100%;
  margin-bottom: 10px;
}

.rule-group {
  display: flex;
  padding-top: 10px;

  .left-cond-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 10px;

    .v-line {
      flex: 1;
      width: 2px;
      background-color: #aaa;
      position: relative;

      &.up {
        margin-top: 10px;

        .h-line {
          top: 0;
        }
      }

      &.down {
        margin-bottom: 20px;

        .h-line {
          bottom: 0;
        }
      }

      .h-line {
        position: absolute;
        width: 30px;
        height: 2px;
        background-color: #aaa;
        left: 0;
      }
    }
  }

  .rule-row {
    display: flex;
    margin-bottom: 10px;
    padding-right: 10px;

    .rule-row-content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .rule-row-item {
        width: 140px;
      }
    }

    .btns {
      display: flex;
      align-items: center;
      color: #ffffff;
    }

    .rule-input-wrap {
      flex-shrink: 0;
      flex-grow: 0;
      width: 150px;
      margin-right: 10px;
    }
  }
}

.hover:hover {
  color: #409eff;
}
</style>
